import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { godMeQuery, orgsQuery } from '@/api/queries'
import { lastCompany } from '@/app/session'
import { t } from '@/i18n'
import { LoadingBlock } from '@/ui/spinner'

export const Route = createFileRoute('/_app/')({
  component: Home,
})

/// «/» is a crossroads, not a page: back to the company last worked in, the
/// first company otherwise, the gods' console for a god who belongs nowhere.
/// (Someone with neither is stopped by the shell's empty state.)
function Home() {
  const god = useQuery(godMeQuery())
  const orgs = useQuery(orgsQuery())
  if (!god.data && !orgs.data) return <LoadingBlock label={t.app.loading} />

  const mine = (orgs.data ?? []).filter((org) => org.role !== null)
  const remembered = lastCompany()
  const target =
    (orgs.data ?? []).find((org) => org.id === remembered && (god.data || org.role !== null)) ??
    mine[0] ??
    null

  if (target) return <Navigate to="/c/$orgId" params={{ orgId: target.id }} replace />
  if (god.data) return <Navigate to="/gods/companies" replace />
  return <LoadingBlock label={t.app.loading} />
}
